import { apiSlice } from "../../app/api/apiSlice";

export const messagesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getMessages: builder.mutation({
			query: ({ messageType }) => ({
				url: `/api/v1/admin/system_messages/${messageType}`,
				method: "GET",
			}),
		}),
		createMessage: builder.mutation({
			query: (formData) => ({
				url: `/api/v1/admin/system_messages/`,
				method: "POST",
				body: formData,
			}),
		}),
		editMessage: builder.mutation({
			query: ({ id, formData }) => ({
				url: `/api/v1/admin/system_messages/${id}/`,
				method: "PATCH",
				body: formData,
			}),
		}),
		deleteMessage: builder.mutation({
			query: (id) => ({
				url: `/api/v1/admin/system_messages/${id}/`,
				method: "DELETE",
			}),
		}),
		getOnlySystemMessages: builder.mutation({
			query: () => ({
				url: `/api/v1/user/login_screen_alert/`,
				method: "GET",
			}),
		}),
		getRoleSpecificMessages: builder.mutation({
			query: (role) => ({
				url: `/api/v1/user/system_messages/`,
				method: "GET",
			}),
		}),
		getGeneralMessageMarkAsRead: builder.mutation({
			query: (id) => ({
				url: `/api/v1/user/system_message/mark_read/${id}/`,
				method: "GET",
			}),
		}),
	}),
});

export const {
	useGetMessagesMutation,
	useCreateMessageMutation,
	useEditMessageMutation,
	useDeleteMessageMutation,
	useGetOnlySystemMessagesMutation,
	useGetRoleSpecificMessagesMutation,
	useGetGeneralMessageMarkAsReadMutation,
} = messagesApiSlice;
